jQuery(document).ready(function ($) {

    $('.offcanvas-search-wrap,#offcanvas-search-label').click(function () {

        $('#offcanvas-search').focus();

    });

    $('#offcanvas-overlay,#hamburger,#topbar-hamburger-label').click(function () {

        if ($("#offcanvas-menu").hasClass("expanded")) {

            let html = $('html');
            let scrollPosition = html.data('scroll-position');
            html.css('overflow', html.data('previous-overflow'));
            window.scrollTo(scrollPosition[0], scrollPosition[1]);

            $("#offcanvas-menu").removeClass("expanded");

        } else {

            $("#offcanvas-menu").addClass("expanded");

            let scrollPosition = [
                self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
                self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            ];

            let html = $('html');

            html.data('scroll-position', scrollPosition);
            html.data('previous-overflow', html.css('overflow'));
            html.css('overflow', 'hidden');
            window.scrollTo(scrollPosition[0], scrollPosition[1]);
        }

    });

    $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').wrap("<div class='flex-video widescreen'/>");

    /*
    $('#offcanvas-overlay').on('scroll touchmove mousewheel', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }); */

    $('.product-details input').on('change', function () {
        if (this.checked) {

            let tab = this;

            $(this).siblings('.tab-content').fadeIn('fast');

            $('.product-details input:checked').not(this).each(function (i, el) {
                $(el).siblings('.tab-content').fadeOut('fast', function () {
                    let offset = $(tab).offset();
                    $('html, body').animate({
                        scrollTop: offset.top
                    });
                });
                $(el).prop('checked', false);
            });

        } else {

            $(this).siblings('.tab-content').fadeOut('fast');

        }
        
    });

    $(".shop-button").click(function () {
        $(".product-shops").fadeToggle("fast");
    });

    $("#more-brands .toggle").click(function () {
        $("#more-brands").addClass("expand");
    });
    
});

